// Round up to the nearest number ending in 9 (245 -> 249, 273 -> 279)
export function roundUpTo9(value) {
  const n = Math.ceil(value);
  const last = n % 10;
  if (last === 9) return n;
  if (last < 9) return n + (9 - last);
  return n + (19 - last);
}

export function calculatePrice(mrp, seriesSlug) {
  const multiplier = seriesSlug === "hinges" ? 1.30 : 1.20;
  return roundUpTo9(Number(mrp) * multiplier);
}

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
